<template>
  <section class="open-salud-about">
    <v-row class="row container-assistance">
      <v-col sm="12" class="main-container-text px-lg-16 my-auto lowpadding">
        <h3 class="title-discount title-discount2" v-html="$t('secondblock.title')"></h3>
<div class="carousel-container">
  <div class="carousel-inner">
    <div class="track">
        <div class="card-container" v-for="card in cards" :key="card.title">
        <v-col>
            <v-row class="priceshadowsmall p-3">
                <v-col cols="12" >
                    <p class="title-offers">{{ card.title }}</p>
                </v-col>
                <v-col cols="12" md="6" >
                  <v-row>
                    <v-col cols="12">
                      <p class="price-befores">{{ card.priceBefore}}</p>
                    </v-col>
                    <v-col cols="12">
                      <p class="subtitle-offer-1s">{{ $t("secondblock.subtitle-offer-1-1") }}</p>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" >
                  <v-row>
                    <v-col cols="12">
                      <p class="price-afters">{{ card.priceAfter }} <span class="asterisk">(*)</span></p>
                    </v-col>
                    <v-col cols="12">
                      <p class="subtitle-offer-2s">{{ $t("secondblock.subtitle-offer-1-2") }}</p>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                    <p class="subtitle-offer-3s">{{ $t("secondblock.subtitle-offer-1-3", { price: card.saveAmount}) }}</p>
                </v-col>
            </v-row>
        </v-col>

        </div>
        
        <div class="card-container">
                <v-col class="height-100">
            <v-row class="priceshadowsmall height-100">
                <v-col class="ismobile" cols="12" >
                    <p class="title-offers">{{ $t("secondblock.title-offer-7") }}</p>
                </v-col>

                <v-col cols="12" >
                    <p class="subtitle-fullheight">{{ $t("secondblock.subtitle-offer-7-3") }}</p>
                </v-col>
            </v-row>
        </v-col>
        </div>
    </div>
  </div>
  <div style="position:relative" class="nav button-line">
    <button style="background-color:transparent;border-color:transparent;transform: rotate(-180deg)" class="prev">
      <i class="prev"><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="black"/></i>
    </button>
    <button style="background-color:transparent;border-color:transparent;transform: rotate(-0deg)" class="next">
     <i class="next"><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="black"/></i>
    </button>
  </div>
</div>
<v-row>


</v-row>
<v-row>


</v-row>
        <v-row>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12">
            <p class="asterisk-text">{{ $t("secondblock.asterisk-text") }}</p>
        </v-col>
    </v-row>
      </v-col>
      <v-col sm="12" class="main-container-text px-lg-16 my-auto column-invert heightautos desktopnone">
         <h3 class="title-discount-invert">{{ $t("secondblock.titleInvert") }}</h3>
         <h4 class="subtitle-discount-invert">{{ $t("secondblock.subtitleInvert") }}</h4>
         <div class="subtitle-list subtitle-list mt-sm-5 iconlist">
          <div>
            <p><v-icon large v-text="'mdi-monitor'"></v-icon>{{ $t('secondblock.iconTitle1') }}</p>
          </div>
          <div>
            <p><v-icon large v-text="'mdi-monitor'"></v-icon>{{ $t('secondblock.iconTitle2') }}</p>
          </div>
          <div>
            <p><v-icon large v-text="'mdi-monitor'"></v-icon>{{ $t('secondblock.iconTitle3') }}</p>
          </div>
          <div>
            <p><v-icon large v-text="'mdi-monitor'"></v-icon>{{ $t('secondblock.iconTitle4') }}</p>
          </div>
          <div>
            <p><v-icon large v-text="'mdi-monitor'"></v-icon>{{ $t('secondblock.iconTitle5') }}</p>
          </div>
          <div>
            <p><v-icon large v-text="'mdi-monitor'"></v-icon>{{ $t('secondblock.iconTitle6') }}</p>
          </div>
        </div>
      </v-col>
    </v-row>

  </section>
</template>

<script>
import es from '@/lang/es/public/views/primesalud-discounts.json'
import en from '@/lang/en/public/views/primesalud-discounts.json'

export default {
  name: 'opensaludpass-main-block',
  i18n: {
    messages: {
      es,
      en,
      mx: es
    }
  },
  data () {
    return {
      //  windowHeight: window.innerHeight,
      // windowWidth: window.innerWidth,
      items: [
        {
          icon: 'mdi-check-circle-outline',
          text: this.$t('subtitle-list-1'),
          path: 'medic-assistance'
        },
        {
          icon: 'mdi-check-circle-outline',
          text: this.$t('subtitle-list-2'),
          path: 'wellness'
        },
        {
          icon: 'mdi-check-circle-outline',
          text: this.$t('subtitle-list-3'),
          path: 'discounts'
        }
      ],
      cards: [
        {
          title: this.$t('secondblock.title-offer-1'),
          priceBefore: '55€',
          priceAfter: '30€',
          saveAmount: '25€'
        },
        {
          title: this.$t('secondblock.title-offer-2'),
          priceBefore: '220€',
          priceAfter: '120€',
          saveAmount: '100€'
        },
        {
          title: this.$t('secondblock.title-offer-3'),
          priceBefore: '45€',
          priceAfter: '15€',
          saveAmount: '30€'
        },
        {
          title: this.$t('secondblock.title-offer-4'),
          priceBefore: '200€',
          priceAfter: '105€',
          saveAmount: '95€'
        },
        {
          title: this.$t('secondblock.title-offer-5'),
          priceBefore: '60€',
          priceAfter: '25€',
          saveAmount: '35€'
        },
        {
          title: this.$t('secondblock.title-offer-6'),
          priceBefore: '70€',
          priceAfter: '30€',
          saveAmount: '40€'
        },
        {
          title: this.$t('secondblock.title-offer-8'),
          priceBefore: '150€',
          priceAfter: `${this.$t('secondblock.from')} 105€`,
          saveAmount: '95€'
        }
      ]
    }
  },
  props: {
    title: {
      type: String,
      default () {
        return this.$t('header-title')
      }
    },
    subtitle: {
      type: String,
      default () {
        return this.$t('upper-header-subtitle')
      }
    },
    button_text: {
      type: String,
      default () {
        return this.$t('hire-now-with-price')
      }
    },
    label_text: {
      type: String,
      default () {
        return this.$t('learn-more-btn')
      }
    }
  },
  methods: {
    buy () {
      this.$helpers.goToWebApp(
        '#dlgRegisterPatient?returnUrl=/HomePaciente#/profile/addsubscription/opensaludpass'
      )
    }
  },
    mounted () {
      const prev = document.querySelector('.prev')
      const next = document.querySelector('.next')
      const track = document.querySelector('.track')
      // const cardContainer = document.querySelector('.carousel-container')
      const cardLenght = 5
        // let carouselWidth = document.querySelector('.carousel-container').offsetWidth
        let cardWidth = document.querySelector('.card-container').offsetWidth

        window.addEventListener('resize', () => {
        cardWidth = document.querySelector('.card-container').offsetWidth
        })
          let index = 0

          if (window.innerWidth <= 425) {
            next.addEventListener('click', () => {
            index++
            prev.classList.add('show')
            track.style.transform = `translateX(-${index * (cardWidth + 80)}px)`
            if (index === (cardLenght + 2)) {
                next.classList.add('hide')
            }
            })

            prev.addEventListener('click', () => {
            index--
            next.classList.remove('hide')
            if (index === 0) {
                prev.classList.add('show')
            }
            track.style.transform = `translateX(-${index * (cardWidth + 80)}px)`
            })

            window.setInterval(() => {
              if (index < cardLenght) {
            index++
            prev.classList.add('show')
            track.style.transform = `translateX(-${index * (cardWidth + 80)}px)`
            if (index === cardLenght) {
                next.classList.add('hide')
            }
              } else if (index === cardLenght) {
                index = index - cardLenght
            next.classList.add('hide')
            if (index === cardLenght) {
                prev.classList.remove('show')
            }
            let i = -1
            for (i = -1; i <= cardLenght; i++) {
            track.style.transform = `translateX(-${index * (cardWidth + 80)}px)`
            }
            next.classList.remove('hide')
              }
              }, 5000)
          } else if (window.innerWidth <= 1552) {
            next.addEventListener('click', () => {
            index++
            prev.classList.add('show')
            track.style.transform = `translateX(-${index * (cardWidth)}px)`
            if (index === (cardLenght + 2)) {
                next.classList.add('hide')
            }
            })

            prev.addEventListener('click', () => {
            index--
            next.classList.remove('hide')
            if (index === 0) {
                prev.classList.add('show')
            }
            track.style.transform = `translateX(-${index * (cardWidth)}px)`
            })

            window.setInterval(() => {
              if (index < (cardLenght + 1)) {
            index++
            prev.classList.add('show')
            track.style.transform = `translateX(-${index * (cardWidth)}px)`
            if (index === (cardLenght + 1)) {
                next.classList.add('hide')
            }
              } else if (index === (cardLenght + 1)) {
                index = index - cardLenght
            next.classList.add('hide')
            if (index === cardLenght) {
                prev.classList.remove('show')
            }
            let i = -1
            for (i = -1; i <= cardLenght; i++) {
            track.style.transform = `translateX(-${index * (cardWidth)}px)`
            }
            next.classList.remove('hide')
              }
              }, 1000)
          } else {
            const cardLenght2 = cardLenght - 1
            next.addEventListener('click', () => {
            index++
            prev.classList.add('show')
            track.style.transform = `translateX(-${index * (cardWidth + 8)}px)`
            if (index === cardLenght) {
                next.classList.add('hide')
            }
            })

            prev.addEventListener('click', () => {
            index--
            next.classList.remove('hide')
            if (index === 0) {
                prev.classList.add('show')
            }
            track.style.transform = `translateX(-${index * (cardWidth + 8)}px)`
            })
            window.setInterval(() => {
              if (index < cardLenght2) {
            index++
            prev.classList.add('show')
            track.style.transform = `translateX(-${index * (cardWidth + 8)}px)`
            if (index === cardLenght) {
                next.classList.add('hide')
            }
              } if (index === cardLenght2) {
                index = index - cardLenght2
            next.classList.remove('hide')
            if (index === 0) {
                prev.classList.remove('show')
            }
          let i = -1
            for (i; i <= cardLenght2; i++) {
            track.style.transform = `translateX(-${index * (cardWidth + 8)}px)`
            }
              }
              }, 5000)
        }
    }
}
</script>

<style lang='scss'>
@import '../../../static-appopensalud/css/public/layout.scss';
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
.carousel-container {
  width: 100%;
  margin: 50px auto;
  min-height: 200px;
  position: relative;
}
.desktopnone{
      display:none;
    }
@media screen and (max-width: 768px) {
  .carousel-container {
    width: 80%;
  }
}
@media screen and (max-width: 1024px) {
  .carousel-container {
    width: 85%;
  }
}
.carousel-container .carousel-inner {
  overflow: hidden;
  background-color: transparent;
  @include mobile(){
    width: 112%;
  }
}
.carousel-container .track {
  display: inline-flex;
  transition: transform 0.5s;
}
.carousel-container .card-container {
  flex-shrink: 0;
  overflow: initial;
  padding-right: 15px;
  box-sizing: border-box;
  @include desktop {
  padding: 1rem;
  width: 33.5%;
  height: auto;
  @media screen and (max-width:1600px) and (min-width:1500px){
      width: 30.5% !important;
      height: auto !important;
  }
   @media screen and (max-width:1499px) and (min-width:1100px){
      width: 28.5% !important;
      height: auto !important;
  }
   @media screen and (max-width:1099px){
      width: 23.5% !important;
      height: auto !important;
  }
  }
  @include desktop-sm {
  padding: 1rem;
  width: 22%;
   @media screen and (max-width:1600px) and (min-width:1500px){
      width: 30.5% !important;
      height: auto !important;
  }
   @media screen and (max-width:1499px) and (min-width:1100px){
      width: 28.5% !important;
      height: auto !important;
  }
   @media screen and (max-width:1099px){
      width: 23.5% !important;
      height: auto !important;
  }
  height: auto;
  }
  @include tablets {
  padding: 5rem;
   @media screen and (max-width:1499px){
      width: 28.5% !important;
      height: auto !important;
  }
  width: 30rem;
  height: 38rem;
  }
  @include mobile(){
  width: 40%;
  padding-right: 3px !important;
  &:not(:first-child) {
        margin-left: 5rem;

    }
  @media screen and (max-width:670px){
      width: 12% !important;
      margin-right: 2px;
  }
  };
}
.carousel-container .card-container .card {
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
  box-sizing: border-box;
  border-radius: 10px;
  display: contents;
  flex-direction: column;
    @media screen and (max-width:1600px) and (min-width: 1500px){
      width: 80%;
      height: 80%;
  }
    @media screen and (max-width:1499px){
      width: 80%;
      height: 80%;
  }
}
.nav button {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 1px solid #aaa;
  position: absolute;
  background-color: transparent;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.nav .prev {
  left: -30px;
}
.nav .prev.show {
  display: block;
}
.nav .next {
  right: -30px;
}
.nav .next.hide {
  display: none;
}
.nav .prev.hide {
  display: none;
}
.button-line{
    position: relative;
    border-top: 1px solid black;
    vertical-align:bottom;
    flex-direction: column;
    top:2rem;
}
.card > * {
  flex: 1;
}
.card .img {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
}
.card .info {
  flex-basis: 40px;
  background: #333;
  color: #fff;
  flex-grow: 0;
  padding: 10px;
  box-sizing: border-box;
}
.heightautos{
    min-height: auto !important;
}

.smallleft{
    margin-right: 1em !important;
}
.priceshadowsmall{
    margin-top: 1em !important;
    background-color: white;
    text-align: center;
    box-shadow: 0px 0px 100px rgba(131, 131, 131, 0.05);
    border-radius: 40px;
    @include mobile() {
      display: inline-block !important;
    }
    @media screen and (max-width:1600px) and (min-width: 1500px){
      height: 23rem !important;
  }
  @media screen and (max-width:1500px) and (min-width:768px){
      height: 23rem !important;
  }
}
.column-invert {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  @include section;
  background-color: $black;

  h3 {
    color: $white;
  }

  .content {
    @include container-padding;

    @include desktop {
      padding: {
        top: 4rem;
        bottom: 4rem;
      }
    }

  }

  .subtitle {
    @include desktop-sm {
      width: 100% !important;
    }

    p {
      color: $gray;
    }

    span {
      color: $gray
    }
    .subtitle-list {
      &.subtitle-list-large {
        p {
          color: $white;
          margin-top: 0 !important;
          margin-bottom: 0 !important;
        }
      }
      &:not(.subtitle-list-large) {
        span {
          color: $white;
        }
      }
      span {
        font-size: 1.25rem;
        display: inline-block;
      }
      > div {
        margin-bottom: 1rem;
        color: $white;
        > span {
          font-size: 1.5rem;
        }
      }

      .v-icon {
        color: $gray;
        margin-right: 1rem;
      }
    }
  }

  .col-bg {
    width: 100%;
  }
}
.title-discount-invert{
    font-size: 3.5rem !important;
line-height: 3.5rem !important;
}
.subtitle-discount-invert{
    font-size: 1em !important;
line-height: 1.6rem !important;
color: #8A8A8A !important;
margin-top: 1.5rem !important;
}
.iconlist div p{
  font-size: 1.25rem !important;
  color: #8A8A8A !important;
  font-weight: bold !important;
}

.iconlist div p i{
  color: #8A8A8A !important;
  padding-right: 20px;
}
.title-offers{
    font-size: 1.5em !important;
    color:black !important;
    font-weight: 600 !important;
    @include mobile() {
          font-size: 1.2rem !important;
    }
    
}
.ismobile {
      @include mobile() {
          margin-bottom: 70% !important;
    }
    }
.price-befores{
    color: #87888a !important;
    font-size: 2.5rem !important;
    text-decoration:line-through;
}

.price-afters{
    color: #3333cc !important;
    font-weight: 600 !important;
    font-size: 2.35rem !important;
    .small {
        font-size: 1rem !important;
    }
}

.subtitle-fullheight {
    color: #3333cc !important;
    font-weight: 300 !important;
    font-size: 1.5rem !important;
    
}

.subtitle-offer-1s{
        color: #87888a !important;
    font-size: 1em !important;
}

.subtitle-offer-2s{
    color: #3333cc !important;
    font-size: 1em !important;
}

.subtitle-offer-3s{
    color: black !important;
    font-size: 1.5em !important;
    font-weight: 600 !important;
}

.asterisk{
    color: black !important;
    font-size: 0.5em !important;
}
.asterisk-text{
    color: black !important;
    font-weight: 600 !important;
    font-size: 1em !important;
}
.btn1 {
  max-width: 22em;
}
.row {
  margin: 0;
}

[class*="col-"] {
  padding: 0px;
}

section.open-salud-about {
  background-color: #e4e4e4;
  font-family: "Space Grotesk", sans-serif;
  text-align: left;
  position:relative;
}

.open-salud-about p {
  color: black;
  line-height: 1.2;
  font-weight: 400;
  font-size: 1rem;
}

.open-salud-about h3 {
  font-size: 4rem;
  line-height: 4.5rem;
  margin-top: 1rem;
}
.open-salud-about .main-container-text {
  @include container-padding;
  padding-left: 7rem !important;
  padding-right: 5rem !important;
}
.open-salud-about .container-assistance {
  margin: 0px;
  min-height: 100vh;

  @include media(mobile, tablets) {
    //flex-direction: column-reverse;
  }
}

.open-salud-about .v-btn {
  color: #3238c4;
  border-color: #3238c4;
  font-size: 0.8rem;
  box-shadow: 13px 12px 39px -5px #87888a;
  background-color: #fff;
}

.open-salud-about .col-img {
  background-color: #fbfafa;
  padding: 0;
  margin-left: 0;
  background-image: url("/static-appopensalud/img/bgs/family-sitting-on-sofa.jpg");
  background-size: cover;
  background-position: center;
  min-height: 50vh;
}

.open-salud-about .g-image {
  width: 100vw;
}

.open-salud-about .v-list.v-sheet.theme--light {
  background-color: transparent;
}
.open-salud-about .v-list-item__title {
  white-space: normal;
}

.open-salud-about .v-list-item.v-list-item--link.theme--light {
  padding: 0;
  width: 25rem;
}
.open-salud-about .floating-container {
  position: relative;
}
.open-salud-about .floating-text {
  color: #3238c4;
  border-right: 1px solid #3238c4;
  padding: 0px 0 0rem 0rem;
  cursor: pointer;
  height: 7.5rem;
  position: absolute;
  left: 90%;
}

.open-salud-about .floating-label {
  transform: rotate(-90deg);
  color: #3238c4;
  font-family: "Space Grotesk", sans-serif;
  right: -2%;
  position: absolute;
  top: 20%;
  margin-top: 4rem;
  font-size: 0.8rem;
}

.height-100 {
    height: 98%;
    @include mobile(){
      width:100%;
    }
}
.height-85 {
    height: 85%;
}
@media (max-width: 1263px) {
  .open-salud-about .floating-text {
    bottom: 0;
  }

  .open-salud-about .floating-label {
    right: 0;
    margin-top: -9%;
  }
  .open-salud-about .container-assistance {
    display: flex;
  }
  .open-salud-about .main-container-text,
  .open-salud-about .col-img {
    max-width: 50%;
  }

  .open-salud-about .button-floating {
    margin-bottom: 1rem;
    color: #3238c4;
    display: flex;
    justify-content: initial;
    align-items: baseline;
  }
    .open-salud-about h3 {
      margin-top: 3rem;
    }
}
@media (max-width: 1024px) {
  .open-salud-about .main-container-text,
  .open-salud-about .col-img {
    max-width: none;
  }
}
@media (max-width: 600px) {
.smallleft{
    margin-right: 0 !important;
}

.subtitle-offer-1{
    font-size: 0.9em !important;
}

.subtitle-offer-2{
    font-size: 1em !important;
}
  .title-discount-invert{
    font-size: 2em !important;
}
.subtitle-discount-invert{
    font-size: 1em !important;
}
.title-discount2{
padding-top: 2rem !important;
}
.iconlist{
  padding-top: 2em;
}
.iconlist div p{
  font-size: 1.2em !important;
}

.iconlist div p i{
  font-size: 2em !important;
}
  .open-salud-about .floating-text {
    left: 85%;
  }

  .open-salud-about .floating-label {
    margin-top: -11%;
  }
  .open-salud-about .main-container-text {
    padding: 2rem;
  }
  .open-salud-about h3 {
      width: 100%;
      margin-left: 0;
      margin-top: 1rem;
      font-size: 2rem;
      line-height: 2.5rem;
    }
  .open-salud-about .v-list-item.v-list-item--link.theme--light {
    width: 70vw;
  }
  .open-salud-about.floating-text,
  .open-salud-about.button-floating {
    margin-bottom: 1rem;
    color: #3238c4;
    display: flex;
    justify-content: space-evenly;
    align-items: baseline;
  }

  .open-salud-about.section-icons {
    margin-top: 35rem;
  }
}

.learn-more {
  position: absolute;
  bottom: 0;
  color: #3238c4;
  border-left: 1px solid #3238c4;
  padding: 0 0 2rem 0.5rem;
  cursor: pointer;
  font-size: 0.8rem;
  transition-duration: 0.5s;

  &:hover {
    font-size: 1rem;
    transition-duration: 0.5s;
  }

  span {
    writing-mode: tb-rl;
    transform: rotate(-180deg);
  }


  @include desktop {
    left: 45vw;
  }

  @include tablets {
    right: 7rem;
    left: initial;
  }

  @include mobile {
    right: 2rem;
    left: initial;
  }
}

.main-container-text  {
  @include desktop {
    padding-top: 100px;
  }
}

@media screen and (min-width: 3840px) {
//For 4K Displays (Ultra HD)
    .heightautos {
        padding-top: 42rem !important;
    }
}

@media (min-width: 1199.98px)  {
    .desktopnone{
      display:none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/public/PrimesaludDiscountsSecondBlock.vue